import { State } from "./State";
export class AllowedGames {
    constructor(types) {
        this.bingo90 = new State(false);
        this.bingo75 = new State(false);
        this.bingoMex = new State(false);
        this.bingoAnimals = new State(false);
        this.bingoCartoon = new State(false);
        this.movies = new State(false);
        this.moviesKids = new State(false);
        this.xmas = new State(false);
        this.football = new State(false);
        this.halloween = new State(false);
        this.superheroes = new State(false);
        this.cartoon = new State(false);
        this.bingo90.set(types.includes('Bingo90'));
        this.bingo75.set(types.includes('Bingo75'));
        this.bingoMex.set(types.includes('BingoMex'));
        this.bingoAnimals.set(types.includes('BingoAnimals'));
        this.bingoCartoon.set(types.includes('BingoCartoon'));
        this.movies.set(types.includes('Movies'));
        this.moviesKids.set(types.includes('MoviesKids'));
        this.xmas.set(types.includes('XMas'));
        this.football.set(types.includes('Football'));
        this.halloween.set(types.includes('Halloween'));
        this.superheroes.set(types.includes('Superheroes'));
        this.cartoon.set(types.includes('Cartoon'));
    }
    toJSON() {
        const types = [];
        if (this.bingo90.value)
            types.push('Bingo90');
        if (this.bingo75.value)
            types.push('Bingo75');
        if (this.bingoMex.value)
            types.push('BingoMex');
        if (this.bingoAnimals.value)
            types.push('BingoAnimals');
        if (this.bingoCartoon.value)
            types.push('BingoCartoon');
        if (this.movies.value)
            types.push('Movies');
        if (this.moviesKids.value)
            types.push('MoviesKids');
        if (this.xmas.value)
            types.push('XMas');
        if (this.football.value)
            types.push('Football');
        if (this.halloween.value)
            types.push('Halloween');
        if (this.superheroes.value)
            types.push('Superheroes');
        if (this.cartoon.value)
            types.push('Cartoon');
        return types;
    }
}
